import MuseumArtworksList from "./MuseumArtworksList";

export default MuseumArtworksList;
